<template>
    <div class="cablesTableContainer">
        <div class="cableTableSection">
            <h4>Origin</h4>
            <p v-for="(cable, index) in origin" :key="index">{{ `CB: ${cable.cb_id}` }}</p>
        </div>
        <div class="cableTableSection">
            <h4>Destination</h4>
            <p v-for="(cable, index) in destination" :key="index">{{ `CB: ${cable.cb_id}` }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CablesTable",
        props: {
            origin : {
                type: Array
            },
            destination : {
                type: Array
            }
        },
        data() {
            return {
                switchBtn: false
            };
        }
    }
</script>

<style scoped>
.cablesTableContainer{
    margin-top: 20px;
    max-height: 150px !important;
    width: 100%;
    background-color: white;
    border-radius: 10px;
    overflow-y: scroll;
    display: flex;
    padding: 10px;
    overflow-y: scroll;
}
.cableTableSection{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.cableTableSection h4{
    text-decoration: underline black;
    margin-bottom: 5px;
}
.cableTableSection p {
    margin-bottom: 5px;
    text-align: start;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/CablesTable.vue